import { useRevalidator } from "react-router";

/**
 * In-tab error state for company profile sections — keeps the profile shell
 * (header, tabs) rendered when a section endpoint fails, with a retry that
 * re-runs the route loaders. Parity with the old client-side tab error states.
 */
export function SectionError({ message }: { message: string }) {
	const revalidator = useRevalidator();

	return (
		<div className="rounded-lg border border-red-200 bg-red-50 p-4">
			<p className="text-sm text-red-800">
				{message}{" "}
				<button
					type="button"
					onClick={() => revalidator.revalidate()}
					className="underline font-medium"
				>
					Zkusit znovu
				</button>
			</p>
		</div>
	);
}
